module.exports = __webpack_public_path__ + "img/landing-carousel-3.3beffec8.png";